$(() => {
  if ($(".destinations-gallery--i").length < 1) {
    return
  }

  $(".destinations-gallery--i").on("click", function openGallery(event) {
    event.preventDefault()
    const photos = $(".destinations-gallery--i")
      .map((idx, element) => $(element).data())
      .get()
    const gallery = new PhotoSwipe({
      dataSource: photos,
      index: $(this).data("index"),
      showHideOpacity: true,
      showAnimationDuration: 0,
    })
    gallery.init()
  })
})
